import { ERP } from '../_base/endpoint';
import global from '../../common/utility/global';
import axios from 'axios';

class claseSunatService {

    /******* QUERIES ******/

    async listarPorIdFamiliaSunat(idFamiliaSunat) {
        const response = await axios
            .get(`${ERP}administracion/clase-sunat/por-familia-sunat/${idFamiliaSunat}`)
            .then(response => { 
                return response.data; 
            })
            .catch(error => {
                console.log(error);
            });
        return response;
    };
}

export default new claseSunatService();